<template>
    <div>
        <el-tooltip placement="top" :popper-class="!show ? 'hide-tooltip' : 'show-tooltip'">
            <div slot="content" style="max-width: 250px;">{{text}}</div>
            <span class="multiline-ellipsis"
                  @mouseenter.stop.prevent="onMouseOver"
            >
                {{text}}
            </span>
        </el-tooltip>
    </div>
</template>
<script>
import {throttle} from 'lodash'
import {ellipseShowPromise} from '@/utils'
export default {
    name: 'hoverEllipsis',
    props:['text'],
    data() {
        return {
            show: false,
        }
    },
    methods:{
        onMouseOver: throttle(function (e) {
            ellipseShowPromise(e.target, false, false).then(hasEllipsis => {
                this.$nextTick(()=>{
                    if(hasEllipsis) {
                        this.show = true
                    } else {
                        this.show = false
                    }
                })
            });
        }, 1000)
        // onMouseOver(e) {
        //     ellipseShowPromise(e.target).then(hasEllipsis => {
        //         this.$nextTick(()=>{
        //             if(hasEllipsis) {
        //                 this.show = true
        //             } else {
        //                 this.show = false
        //             }
        //         })
        //     });
        // }
    }
}
</script>
<style lang="scss" scoped>
.multiline-ellipsis {
    position: relative;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

</style>
<style lang="scss">
.hide-tooltip {
    visibility: hidden;
}
</style>
